export const SUBMIT_PLAYER_PURCHASE = "SUBMIT_PLAYER_PURCHASE";
export const SUBMIT_PLAYER_PURCHASE_SUCCESS = "SUBMIT_PLAYER_PURCHASE_SUCCESS";
export const SUBMIT_PLAYER_PURCHASE_ERROR = "SUBMIT_PLAYER_PURCHASE_ERROR";
export const SUBMIT_PLAYER_PURCHASE_STRIPE = "SUBMIT_PLAYER_PURCHASE_STRIPE";
export const SUBMIT_PLAYER_PURCHASE_STRIPE_SUCCESS =
  "SUBMIT_PLAYER_PURCHASE_STRIPE_SUCCESS";
export const SUBMIT_PLAYER_PURCHASE_STRIPE_ERROR =
  "SUBMIT_PLAYER_PURCHASE_STRIPE_ERROR";
export const GET_PAYMENT_INTENT_URL_STRIPE = "/v2/stripe/getPaymentIntent";
export const POST_PURCHASE_URL_STRIPE = "/v2/stripe/postPurchase";
